import { ColumnDef, createColumnHelper } from "@tanstack/react-table";
import { IconButton, Text } from '@chakra-ui/react';

import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import { ActorSettingsElementT } from "shared/api/types/services";
import CutText from "shared/components/CutText";
import { PathsE, PathsParams } from "shared/routes";
import useGetColors from "shared/hooks/useGetColors";
import MuiIcon from "components/MuiIcon";
import Link from "shared/components/Link";

export const useGetGetBreadcrumbs = () => {
  const { t } = useTranslation();
  return [
    {
      path: PathsE.HOME,
      text: t('general.home'),
    },
  ];
}

interface Params {
  serviceId: string,
}

export const useGetColumns = ({ serviceId }: Params) => {
  const { blue500 } = useGetColors();
  const { t } = useTranslation();
  const columnHelper = createColumnHelper<ActorSettingsElementT>();

  return useMemo(
    () => [
      columnHelper.accessor('id', {
        header: t('services.table.id'),
        id: 'id',
        cell: ({ getValue }) => (
          <CutText fontWeight="700">
            {getValue()}
          </CutText>
        ),
        meta: {
          isSorting: false,
          styles: {
            sizes: {
              width: '90px',
              maxW: '90px',
            }
          }
        }
      }),
      columnHelper.accessor('text', {
        header: t('forms.text'),
        id: 'text',
      }),
      columnHelper.accessor('description', {
        header: t('services.table.description'),
        id: 'description',
        cell: ({ getValue }) => (
          <Text dangerouslySetInnerHTML={{ __html: getValue() }} />
        ),
        meta: {
          styles: {
            sizes: {
              maxW: '300',
            }
          }
        }
      }),
      // columnHelper.accessor('createdAt', {
      //   header: t('services.table.createdAt'),
      //   id: 'createdAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      // columnHelper.accessor('updatedAt', {
      //   header: t('services.table.updatedAt'),
      //   id: 'updatedAt',
      //   cell: ({ getValue }) => formatDateToHuman(getValue(), false),
      //   meta: {
      //     isNumeric: true,
      //     styles: {
      //       sizes: {
      //         width: '120px'
      //       }
      //     }
      //   }
      // }),
      columnHelper.accessor('id', {
        header: '',
        id: 'actions',
        cell: ({ row }) => (
          <Link<PathsParams[PathsE.UPDATE_ACTOR_SETTING]>
            path={PathsE.UPDATE_ACTOR_SETTING}
            pathsParams={{ serviceId, actorSettingId: row.original.id }}
          >
            <IconButton
              mr="2"
              aria-label="Edit"
              borderRadius="10px"
              backgroundColor="transparent"
              icon={<MuiIcon name="edit" color={blue500} />}
            />
          </Link>
        ),
        meta: {
          styles: {
            sizes: {
              width: '44px'
            }
          }
        }
      }),
    ] as ColumnDef<ActorSettingsElementT>[],
    [t]
  );
};
